<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
@import '@/scss/_colors.scss';

#app {
  font-family: 'proxima-nova', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 100vh;
  color: $text-color;
  background-color: $light;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: rgba($dark-blue, 0.3);
  border-radius: 15px;
}

input,
select {
  outline: none !important;
  box-shadow: none !important;
  border: 1px solid $input-border-color;
}
</style>
